import request from '../utils/request';
const querystring = require('querystring')
//获取渠道下拉框数据
export const fetchSelect = query => { 
    var list = request({
        url: 'comGoods/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const fetchSelect2 = query => { 
    var list = request({
        url: 'comGoods/getListFetch2.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const fetchSelect3 = query => {
    var list = request({
        url: 'comGoods/getListFetch3.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
//获取列表数据
export const fetchData = query => { 
    var list = request({
        url: 'comGoods/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 

export const fetchGroupData = query => { 
    var list = request({
        url: 'comGoods/selectGroupPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 
export const fetchData3 = query => { 
    var list = request({
        url: 'comMemGoods/selectPage2.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getRiskData = query => { 
    var list = request({
        url: 'comGoodsRisk/getData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const changeGive = query => { 
    var list = request({
        url: 'comMemGoods/changeGive.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const setLimitConfig = query => { 
    var list = request({
        url: 'comMemGoods/setLimitConfig.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const setRiskConfig = query => { 
    var list = request({
        url: 'comGoodsRisk/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const setMemRisk = query => { 
    var list = request({
        url: 'comMemGoods/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const downOrderExcel = query => { 
    var list = request({
        url: 'comGoodsDoc/getGoodsDocExcel.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const fetchData2 = query => { 
    var list = request({
        url: 'comGoods/selectPage2.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 
 
export const getGoodsConfig = query => { 
    var list = request({
        url: 'comGoodsConfig/getData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const saveGoodsConfig = query => { 
    var list = request({
        url: 'comGoodsConfig/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getGoodsBind = query => { 
    var list = request({
        url: 'comGoodsBind/getData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const saveGoodsBind = query => { 
    var list = request({
        url: 'comGoodsBind/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const fetchCopy = query => { 
    var list = request({
        url: 'comGoods/fetchCopy.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//保存新增
export const saveForm = query => { 
    var list = request({
        url: 'comGoods/insertBack.do',
        method: 'post', 
        data: querystring.stringify(query),  
    }); 
    return list;
};
//详情图上传服务器
export const uploadDetailPlain = query => {  
    var list = request({
        url: 'common/uploadDetailPlain.do',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' }, 
        method: 'post',
        data:  query, 
    }); 
    return list;
};




//主图上传服务器
export const uploadMainPlain = query => {  
    var list = request({
        url: 'common/uploadMainPlain.do',
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
};
export const uploadMasterPlain = query => {  
    var list = request({
        url: 'common/uploadMasterPlain.do',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' }, 
        method: 'post',
        data:  query, 
    }); 
    return list;
};

//主图删除 
export const removeMasterPlain = query => {  
    var list = request({
        url: 'common/removeMasterPlain.do', 
        method: 'post',
        data:  querystring.stringify(query), 
    });
    return list;
};

//详情图删除 
export const removeDetailPlain = query => {  
    var list = request({
        url: 'common/removeDetailPlain.do', 
        method: 'post',
        data:  querystring.stringify(query), 
    });
    return list; 
};
//获取详情图
export const getGoodsDetail = query => {  
    var list = request({
        url: 'comGoods/getDetailBack.do', 
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
}; 
//复制商品信息
export const handleCopy = query => {  
    var list = request({
        url: 'comGoods/handleCopy.do', 
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
};
//删除
export const handDelete = query => {  
    var list = request({
        url: 'comGoods/delete.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};
//批量删除 
export const handDeleteBatch = query => {  
    var list = request({
        url: 'comGoods/handDeleteBatch.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};
//批量复制
export const handCopyBatch = query => {
    var list = request({
        url: 'comGoods/insertCopyBatch',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

//修改
export const changeForm = query => {  
    var list = request({
        url: 'comGoods/update.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};
 

//上下架
export const changeStatus = query => {  
    var list = request({
        url: 'comGoods/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

export const getGoodsAnalysis = query => {
    var list = request({
        url: 'comGoods/getGoodsAnalysis.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

//修改排序id 
export const updateAesId = query => {  
    var list = request({
        url: 'comGoods/updateAesId.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};





